module.exports = __webpack_public_path__ + "media/images/teams-d63886ea939c1bc399ce66efa8b49290.png";